import backIcon from "@assets/images/back.svg";
import BoxSVG from "@assets/images/box-export.svg";
import DatepickerIcon from "@assets/images/date-picker.svg";
import externalLinkIcon from "@assets/images/external-link.svg";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import { formatConditionGroup } from "@saleor/changeOrderExport/utils";
import {
  conditionGroupOptions,
  IListMaterial,
  TypeSubmit
} from "@saleor/changeOrderExport/views/ViewEditOrder/types";
import Checkbox from "@saleor/components/Checkbox";
import DatePicker from "@saleor/components/DatePicker";
import DatePickerApplyAll from "@saleor/components/DatePickerApplyAll/DatePickerApplyAll";
import DecimalFormat from "@saleor/components/DecimalFormat";
import MyTypography from "@saleor/components/MyTypography";
import NumberFormat from "@saleor/components/NumberFormat/NumberFormat";
import PopoverApplyAll from "@saleor/components/PopoverApplyAll";
import SearchRoute from "@saleor/components/SearchRoute";
import { SingleSelectField } from "@saleor/components/SingleSelectField";
import { SingleTextField } from "@saleor/components/SingleTextField";
import SingleTextFieldNoBlock from "@saleor/components/SingleTextField2";
import Skeleton from "@saleor/components/Skeleton";
import StickyHorizontalScrollBar from "@saleor/components/StickyHorizontalScrollBar";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { TablePaginationCustom } from "@saleor/components/TablePaginationCustom";
import TextAreaField from "@saleor/components/TextAreaField";
import { REGEX_ONLY_NUMBER, REGEX_ONLY_NUMBER_CHARACTER } from "@saleor/config";
import FullScreenButton from "@saleor/createOrderExport/components/FullScreenButton";
import { MAX_LENGTH_REF_PI } from "@saleor/createOrderExport/components/MaterialItemTab/const";
import { ExportOrderSortField } from "@saleor/createOrderExport/urls";
import EmptyProduct from "@saleor/createOrderExport/views/CartDetailExport/EmptyProduct";
import { createPackingList } from "@saleor/createOrderExport/views/CreateOrderView/utils";
import {
  ContractExportOrderAllItemBySoNoQuery,
  EOrderingProductionStatus,
  IPlanOrderItemStatus,
  ScgExportRejectReason
} from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import useBulkActions, {
  UseBulkActionsProps
} from "@saleor/hooks/useBulkActions";
import { renderCollection } from "@saleor/misc";
import { ListProps, RelayToFlatNoEdge, SortPage } from "@saleor/types";
import { getPlainTextFromEnum } from "@saleor/utils/message";
import {
  calculateNewPackage,
  calculateNewPalletNo,
  calculateTheWeight
} from "@saleor/utils/number";
import { getArrowDirection } from "@saleor/utils/sort";
import classNames from "classnames";
import moment from "moment-timezone";
import React, { useEffect, useRef, useState } from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

import ModalInputParameter from "../../ModalInputParameter";
import { getFormik } from "./formik";
import useStyles from "./styles";

export interface MaterialItemTabEditProps
  extends ListProps,
    SortPage<ExportOrderSortField> {
  data: RelayToFlatNoEdge<
    ContractExportOrderAllItemBySoNoQuery["exportOrderWithAllItemsBySoNo"]
  >;
  latestPageItemNumber: number | null;
  onPreviousFirstPage: () => void;
  onNextLastPage: () => void;
  totalCount?: number;
  submitOrderCall?: number;
  handleSubmitOrder?: (value?, type?) => void;
  listMaterial: IListMaterial[];
  listMaterialAll: IListMaterial[];
  bulkActions: UseBulkActionsProps;
  setListMaterial: (value) => void;
  currency: string;
  handleRevertItem?: (itemNo) => void;
  isOrderInvalid?: boolean;
}

enum DELIVERY_STATUS {
  PARTIAL_DELIVERY = "B"
}

const totalCols = 20;

const MaterialItemTabEdit: React.FC<MaterialItemTabEditProps> = ({
  data,
  settings,
  onUpdateListSettings,
  onNextPage,
  onPreviousPage,
  pageInfo,
  disabled,
  onSort,
  sort,
  onNextLastPage,
  latestPageItemNumber,
  onPreviousFirstPage,
  totalCount,
  handleSubmitOrder,
  submitOrderCall,
  listMaterial,
  setListMaterial,
  listMaterialAll,
  bulkActions,
  currency,
  handleRevertItem,
  isOrderInvalid
}) => {
  const intl = useIntl();
  const classes = useStyles();
  const [appState, dispatchAppState] = useAppState();
  const { fullScreen } = appState;
  const [tab, setTab] = useState<number>(0);
  const formik = getFormik(listMaterial);
  const [reRender, setReRender] = useState<boolean>(false);
  const [isOpenModalInputParameter, setIsOpenModalInputParameter] = useState<
    boolean
  >(false);
  const [isPartialDelivery, setIsPartialDelivery] = useState<boolean>(false);
  const [orderLine, setOrderLine] = useState(null);
  const [keyComponent, setKeyComponent] = useState<number>(0);
  const [openPlant, setOpenPlant] = useState<boolean>(false);
  const [resetApplyPlant, setResetApplyPlant] = useState<boolean>(false);
  const [resetApplyDate, setResetApplyDate] = useState<boolean>(false);

  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const { isSelected, listElements, reset, toggle, set } = bulkActions;

  const isOrderStatusPartialDelivery = line =>
    line?.deliveryStatus === DELIVERY_STATUS.PARTIAL_DELIVERY;

  const handleOpenModalInputParameter = orderId => {
    setKeyComponent(prev => prev + 1);
    setIsOpenModalInputParameter(true);
    setOrderLine(orderId);
    setIsPartialDelivery(isOrderStatusPartialDelivery(orderId));
  };

  const handleCloseModalInputParameter = () => {
    setIsOpenModalInputParameter(false);
  };

  useEffect(() => {
    setDelivery(
      listMaterialAll.filter(item => item.untimatedTol).map(line => line.itemNo)
    );
  }, [data]);

  useEffect(() => {
    reset();
  }, []);

  useEffect(() => {
    dispatchAppState({
      payload: {
        tabMaterial: tab
      },
      type: "setTabMaterial"
    });
  }, [tab]);

  useEffect(() => {
    setReRender(prevState => !prevState);
  }, [fullScreen]);

  useEffect(() => {
    setReRender(prevState => !prevState);
    if (containerRef.current) {
      containerRef!.current!.scrollLeft = 0;
    }
  }, [tab]);

  const {
    isSelected: isErrorQuantity,
    listElements: listElementsError,
    add: addError,
    remove: removeError
  } = useBulkActions([]);

  const {
    isSelected: isSelectedDelivery,
    listElements: listDeliveryDelivery,
    reset: resetDelivery,
    toggle: toggleDelivery,
    set: setDelivery
  } = useBulkActions([]);

  const onChangeTab = (tab: number) => {
    setTab(tab);
  };

  const renderTabTable = () => (
    <div className={classes.tabBox}>
      <div
        className={classNames(
          classes.boxShadowTab,
          tab === 0 ? classes.z1 : classes.z0
        )}
      >
        <button
          id="sales-condition-tab"
          data-testid="sales-condition-tab"
          onClick={() => {
            onChangeTab(0);
          }}
          onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              onChangeTab(0);
            }
          }}
          className={classNames(
            classes.tableTab,
            tab === 0 ? classes.active : classes.notActive
          )}
        >
          <MyTypography variant={"body2"}>
            {intl.formatMessage({
              defaultMessage: "Sales Condition"
            })}
          </MyTypography>
        </button>
      </div>
      <div
        className={classNames(
          classes.boxShadowTab,
          tab === 1 ? classes.z1 : classes.z0
        )}
      >
        <button
          id="order-details-tab"
          data-testid="order-details-tab"
          onClick={() => {
            onChangeTab(1);
          }}
          onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              onChangeTab(1);
            }
          }}
          className={classNames(
            classes.tableTab,
            classes.tabB,
            tab === 1 ? classes.active : classes.notActive
          )}
        >
          <MyTypography variant={"body2"}>
            {intl.formatMessage({
              defaultMessage: "Order Details"
            })}
          </MyTypography>
        </button>
      </div>
    </div>
  );

  const renderTabA = () => (
    <>
      <TableCellHeader
        width={120}
        style={{ minWidth: "120px", borderRight: 0 }}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "จำนวน" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={72} style={{ minWidth: "72px" }}>
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={80}
        textAlign={"right"}
        style={{ minWidth: "80px" }}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "น้ำหนัก" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={128}
        style={{ minWidth: "128px" }}
        textAlign={"center"}
      >
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={128} style={{ minWidth: "128px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Item Cat (EO)" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={128}
        style={{ minWidth: "128px" }}
        textAlign={"right"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "ราคา/หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={88} style={{ minWidth: "88px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Currency" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={128} style={{ minWidth: "128px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Plant" })}
        </MyTypography>
        <Button
          ref={anchorRef}
          className={classNames(
            classes.buttonApply,
            openPlant && classes.btnApplyOpen
          )}
          disabled={isR5}
          variant="contained"
          onClick={() => setOpenPlant(true)}
          id="apply-all-button"
          name="apply-all-button"
          data-testid="apply-all-plant-button"
        >
          {openPlant && (
            <SVG src={DatepickerIcon} className={classes.svgDatePicker} />
          )}
          Apply all
        </Button>
        <PopoverApplyAll
          anchorEl={anchorRef.current}
          onClose={() => setOpenPlant(false)}
          open={openPlant}
          onOk={handleOnApplyAllPlant}
          title={"Plant"}
          maxLengthInput={4}
        />
      </TableCellHeader>
      <TableCellHeader width={128} style={{ minWidth: "128px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Ref. PI Stock" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={190} style={{ minWidth: "190px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Original Date" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={210}
        style={{ minWidth: "210px" }}
        className={classes.borderRight}
      >
        <MyTypography variant={"subtitle3"}>
          <div>{intl.formatMessage({ defaultMessage: "Request Date" })}</div>
          <DatePickerApplyAll
            disabled={isR5}
            onApplyAll={handleApplyAllRequestDate}
          />
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={190}
        style={{ minWidth: "190px" }}
        className={classes.borderRight}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Confirm Date" })}
        </MyTypography>
      </TableCellHeader>

      <TableCellHeader width={190} style={{ minWidth: "190px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Item Status" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={190} style={{ minWidth: "190px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PO No.(Outsource)" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={190} style={{ minWidth: "190px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "PO Status(Outsource)" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader>
        {intl.formatMessage({ defaultMessage: "(P)" })}
      </TableCellHeader>
    </>
  );

  const renderTabB = () => (
    <>
      <TableCellHeader width={470} style={{ minWidth: "470px" }} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Route" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={"220px"}
        style={{ minWidth: "220px" }}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Condition Group 1" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={160} style={{ minWidth: "160px" }} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Material Group 2" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        textAlign={"center"}
        style={{ minWidth: "112px" }}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"} align="center">
          {intl.formatMessage({ defaultMessage: "Commission (%)" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"} align="center">
          {intl.formatMessage({ defaultMessage: "Commission amount" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Com. Unit" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={280}
        style={{ minWidth: "280px" }}
        textAlign={"center"}
        className={classes.customCell}
        colSpan={3}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Delivery Tolerance" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        align={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Roll Diameter" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        align={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Roll Core Diameter" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "No. of Rolls" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        align={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Ream/Roll per Pallet" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Pallet Size" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Pallet No." })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        align={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "No. of Package" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={440}
        style={{ minWidth: "440px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Packing List" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={200}
        style={{ minWidth: "200px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Shipping Point" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={440}
        style={{ minWidth: "440px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Remark" })}
        </MyTypography>
      </TableCellHeader>
    </>
  );

  const handleClickCheckBox = (e, id: string) => {
    toggleDelivery(id);
    const check = isSelectedDelivery(id);
    handleChangeInput(e, id, e.target.name, !check);
  };

  const handleChangeRoute = (route, itemId) => {
    const indexOfItem = listMaterial.findIndex(item => item.itemNo === itemId);

    const value = {
      target: {
        value: route,
        name: `route[${indexOfItem}]`
      }
    };
    handleChangeInput(value, itemId, "route");
  };
  const getAllQuantityByMatCode = (matCode, itemNoExclude) => {
    const listSameMatCode = listMaterialAll.filter(
      item => item.material === matCode && item.itemNo !== itemNoExclude
    );
    return listSameMatCode.reduce(
      (totalQuantity, item) => (totalQuantity += +item.quantity),
      0
    );
  };

  const handleChangeInput = (
    event: any,
    id: string,
    field: string,
    valueExtra?
    // line?: IListMaterial
  ) => {
    const value = event.target.value;
    if (field !== "quantity") {
      formik.setFieldValue(event.target.name, event.target.value, true);
    }

    const validateRequestDate = (item, dateValue) => {
      const isNewDateAfter = moment(dateValue).isSameOrAfter(
        moment().format("YYYY-MM-DD")
      );
      const filterDataRequestDate = data.orderItems.find(
        item => item.itemNo === id
      );

      if (
        moment(filterDataRequestDate.requestedDate, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        ) === dateValue
      ) {
        item.errorDate = false;
      } else {
        item.errorDate = !isNewDateAfter;

        if (isCompletedProduction(item) || isFullCommittedOrder(item)) {
          item.errorDate = moment(dateValue).isBefore(
            moment().format("YYYY-MM-DD")
          );
          item.dateBeforeConfirm = moment(dateValue).isBefore(
            moment().format("YYYY-MM-DD")
          );
        }
      }
    };

    let newState = listMaterialAll.map(item => {
      if (item.itemNo === id) {
        if (field === "quantity") {
          const value = Number(event.target.value);
          const totalQuantitySameMatCode = getAllQuantityByMatCode(
            item.material,
            item.itemNo
          );
          const totalQuantity = totalQuantitySameMatCode + value;
          const limitQuantity = +item.itemRemain || 0;
          const checkQuantity = totalQuantity > limitQuantity;

          const reamRollPerPallet = item.reamRollPerPallet || 0;
          item.noOfPackage = calculateNewPackage(
            value,
            reamRollPerPallet
          ).toString();
          if (!event.target.value) {
            item.textErrorMessageQuantity = "โปรดระบุจำนวนที่ต้องการ";
            addError(item.itemNo);
          }
          // else if (
          //   isAfterProduction(item) &&
          //   value > Number(line.originQuantity)
          // ) {
          //   item.textErrorMessageQuantity = "ไม่สามารถเพิ่มจำนวนได้";
          //   addError(item.itemNo);
          // }
          // else if (
          //   isDuringProduction(item) &&
          //   value < Number(line.assignQuantity)
          // ) {
          //   item.textErrorMessageQuantity =
          //     "โปรดระบุจำนวนให้มากกว่า assigned quantity";
          //   addError(item.itemNo);
          //   formik.setFieldValue(event.target.name, event.target.value, true);
          // }
          else {
            if (checkQuantity) {
              item.textErrorMessageQuantity =
                "จำนวนที่สั่งมีมากกว่าจำนวนคงเหลือ";
              addError(item.itemNo);
            } else {
              removeError(item.itemNo);
              item.textErrorMessageQuantity = "";
            }
            if (isOrderInvalid && value > Number(item.originQuantity)) {
              item.textErrorMessageQuantity =
                "ไม่สามารถเพิ่มจำนวนได้ เนื่องจาก Contract Invalid/Completed";
              addError(item.itemNo);
            }
            formik.setFieldValue(event.target.name, event.target.value, true);
          }
        }
        if (field === "rollPerPallet") {
          const value = parseInt(event.target.value, 10) || 0;
          item.noOfPackage = calculateNewPackage(
            item.itemQty,
            value
          ).toString();
        }
        if (field === "requestDate") {
          validateRequestDate(item, value);
        }
        return {
          ...item,
          [field]: valueExtra || event.target.value,
          isChange: true
        };
      }
      return item;
    });
    // common validation for all rows when other field changes
    if (field !== "requestDate") {
      newState = newState.map(item => {
        if (item.itemNo === id) {
          validateRequestDate(item, item.requestDate);
        }
        return { ...item };
      });
    }
    if (field === "quantity" || field === "rollPerPallet") {
      const newList = [...newState];
      newList.forEach((item, index) => {
        item.palletNo = calculateNewPalletNo(newList, index);
        item.packingList = createPackingList(item);
      });
      setListMaterial(newList);
    } else {
      setListMaterial(newState);
    }
  };

  const handleCheckboxAllDelivery = () => {
    if (
      listDeliveryDelivery.length ===
      listMaterialAll.filter(item => !isCancelItem(item)).length
    ) {
      resetDelivery();
      updateCheckboxAll(false);
      return;
    }
    setDelivery(
      listMaterialAll
        .filter(item => !isCancelItem(item))
        .map(item => item.itemNo)
    );
    updateCheckboxAll(true);
  };

  const updateCheckboxAll = value => {
    const newState = listMaterialAll
      .filter(item => !isCancelItem(item))
      .map(item => ({
        ...item,
        deliveryTolUnlimited: value,
        isChange: true
      }));
    setListMaterial(newState);
  };

  const handleCheckboxAll = () => {
    if (
      listElements.length ===
      listMaterial.filter(item => !isCancelItem(item)).length
    ) {
      reset();
      return;
    }
    set(
      listMaterial.filter(item => !isCancelItem(item)).map(item => item.itemNo)
    );
  };

  const handleSaveInputParameter = choice => {
    setListMaterial(prev =>
      prev.map(item => {
        if (item.itemNo === orderLine.itemNo) {
          return {
            ...item,
            inquiryMethod: choice,
            isChange: true
          };
        }
        return item;
      })
    );
    setIsOpenModalInputParameter(false);
  };

  const handleOnApplyAllPlant = value => {
    setResetApplyPlant(prevState => !prevState);
    formik.setFieldValue(
      "plant",
      formik.values.plant.map((_, idx) => {
        if (
          !isContainer(listMaterial[idx]) &&
          !isCompleteDelivery(listMaterial[idx])
        ) {
          return value;
        }
        return null;
      })
    );
    setListMaterial(oldData =>
      oldData.map(item => ({
        ...item,
        plant:
          isContainer(item) || isCompleteDelivery(item) ? item.plant : value,
        isChange: true
      }))
    );
    setOpenPlant(false);
  };

  const handleApplyAllRequestDate = value => {
    setResetApplyDate(prevState => !prevState);
    formik.setFieldValue(
      "requestDate",
      formik.values.requestDate.map((_, idx) => {
        if (
          !isContainer(listMaterial[idx]) &&
          !isCompleteDelivery(listMaterial[idx]) &&
          !isCancelItem(listMaterial[idx])
        ) {
          return value;
        }
        return null;
      })
    );
    setListMaterial(oldData =>
      oldData.map(item => {
        if (!isCancelItem(item)) {
          return {
            ...item,
            requestDate: isCompleteDelivery(item) ? item.requestDate : value,
            isChange: true
          };
        } else {
          return item;
        }
      })
    );
  };

  const checkErrorByField = (field: string, index) =>
    !!(formik.errors[field] && formik.errors[field][index]);

  const getErrorTextQuantity = (field: string, index, item) =>
    (formik.errors[field] && formik.errors[field][index]) ||
    (isErrorQuantity(item.itemNo) && item.textErrorMessageQuantity) ||
    "";

  useEffect(() => {
    if (submitOrderCall) {
      const listErrorDate = listMaterialAll.filter(
        item => item.errorDate || item.dateBeforeConfirm
      );
      if (
        formik.isValid &&
        !listElementsError.length &&
        !listErrorDate.length
      ) {
        handleSubmitOrder(null, TypeSubmit.SUBMIT_MATERIAL);
      } else {
        handleSubmitOrder({ error: true }, TypeSubmit.SUBMIT_MATERIAL);
      }
    }
  }, [submitOrderCall]);

  const renderActionItem = item => {
    if (item.rejectReason === ScgExportRejectReason.YES) {
      return (
        <Button
          className={classes.btnIcon}
          onClick={() => handleRevertItem(item.itemNo)}
          disabled={disabled}
        >
          <SVG src={backIcon} className={classes.backIcon} />
        </Button>
      );
    }
  };

  const textErrorDate = intl.formatMessage({
    defaultMessage:
      "กรุณาเปลี่ยน “Request Date” (ไม่สามารถใส่วันที่ผ่านมาแล้วได้)"
  });

  const textErrorDateConfirm = intl.formatMessage({
    defaultMessage: "ไม่สามารถเลือกวันที่ในอดีตได้"
  });

  const isContainer = item => item?.itemCategory === "ZKC0";

  const isK01K09 = item =>
    item.materialGroup1?.includes("K01") ||
    item.materialGroup1?.includes("K09");

  const isCancelItem = item => item.rejectReason === ScgExportRejectReason.YES;

  const isR5 = !!listMaterial.find(e => e.flagR5);

  const isSpecialPlant = item => item.isMaterialOutsource;

  const isDuringProduction = item =>
    item.itemProductionState === EOrderingProductionStatus.DURING_PRODUCTION;

  const isAfterProduction = item =>
    item.itemProductionState === EOrderingProductionStatus.AFTER_PRODUCTION;

  const isItemProducing = item =>
    item.itemStatusEn === IPlanOrderItemStatus.PRODUCING;

  const isCompletedProduction = item =>
    item.itemStatusEn === IPlanOrderItemStatus.COMPLETED_PRODUCTION;
  const isFullCommittedOrder = item =>
    item.itemStatusEn === IPlanOrderItemStatus.FULL_COMMITTED_ORDER;
  const isCompleteDelivery = item =>
    item.itemStatusEn === IPlanOrderItemStatus.COMPLETE_DELIVERY;
  return (
    <>
      <div hidden={fullScreen}>
        <MyTypography variant="subtitle1" className={classes.header}>
          <SVG width={24} height={24} className={classes.svg} src={BoxSVG} />
          {intl.formatMessage({ defaultMessage: "รายละเอียดสินค้า" })}
        </MyTypography>
      </div>
      {listMaterial?.length ? (
        <>
          <div className={classes.topBox}>
            <div className={classes.deleteBox} />
            <FullScreenButton />
          </div>
          <div
            className={classes.tableRoot}
            style={{ overflowX: "auto" }}
            ref={containerRef}
          >
            {renderTabTable()}
            <Table>
              <TableHead>
                <TableRow>
                  <TableCellHeader
                    rowSpan={2}
                    align={"center"}
                    className={classNames(
                      classes.cellCheckBox,
                      classes.tableHeader,
                      classes.freezeCell,
                      classes.borderLeft
                    )}
                  >
                    <div className={classes.boxCheckBox}>
                      <Checkbox
                        className={classes.checkBox}
                        size={"small"}
                        checked={
                          listMaterial.filter(item => !isCancelItem(item))
                            .length !== 0 &&
                          listElements.length ===
                            listMaterial.filter(item => !isCancelItem(item))
                              .length
                        }
                        indeterminate={
                          listElements.length > 0 &&
                          listElements.length <
                            listMaterial.filter(item => !isCancelItem(item))
                              .length
                        }
                        onClick={() => handleCheckboxAll()}
                        disabled={disabled || isR5}
                        name="checkbox-all-button"
                        id="checkbox-all-button"
                        data-testid="checkbox-all-button"
                      />
                    </div>
                  </TableCellHeader>
                  <TableCellHeader
                    rowSpan={2}
                    className={classes.freezeCell1}
                    style={{ width: "90px", minWidth: "90px" }}
                    textAlign={"center"}
                    direction={
                      sort.sort === ExportOrderSortField.item_no
                        ? getArrowDirection(sort.asc)
                        : undefined
                    }
                    arrowPosition="right"
                    onClick={() => onSort(ExportOrderSortField.item_no)}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({ defaultMessage: "Item No." })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.freezeCell2}
                    style={{ width: "180px", minWidth: "180px" }}
                    rowSpan={2}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({ defaultMessage: "Mat. Code" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.freezeCell3}
                    style={{ width: "320px", minWidth: "320px" }}
                    rowSpan={2}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({
                        defaultMessage: "Mat. Description"
                      })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.freezeCell4}
                    style={{ width: "80px", minWidth: "80px" }}
                    rowSpan={2}
                  />
                  {tab === 0 ? renderTabA() : renderTabB()}
                </TableRow>
                {tab === 1 && (
                  <TableRow>
                    <TableCellHeader
                      width={93}
                      style={{ minWidth: "93px" }}
                      className={classNames(
                        classes.customCell,
                        classes.noBorderRight,
                        classes.thDelivery
                      )}
                    >
                      <span className={classes.delivery}>Under (%)</span>
                    </TableCellHeader>
                    <TableCellHeader
                      width={93}
                      style={{ minWidth: "93px" }}
                      className={classNames(
                        classes.customCell,
                        classes.noBorderRight,
                        classes.thDelivery
                      )}
                    >
                      <span className={classes.delivery}>Over (%)</span>
                    </TableCellHeader>
                    <TableCellHeader
                      width={100}
                      style={{ minWidth: "100" }}
                      className={classNames(
                        classes.borderRight,
                        classes.customCell,
                        classes.unlimited,
                        classes.thDelivery
                      )}
                    >
                      <span className={classes.delivery}>
                        <Checkbox
                          className={classes.checkBox}
                          size={"small"}
                          checked={
                            isR5
                              ? false
                              : listDeliveryDelivery.length ===
                                listMaterialAll.length
                          }
                          indeterminate={
                            listDeliveryDelivery.length > 0 &&
                            listDeliveryDelivery.length < listMaterialAll.length
                          }
                          onClick={() => handleCheckboxAllDelivery()}
                          disabled={disabled || isR5}
                          name="checkbox-header-delivery"
                          id="checkbox-header-delivery"
                          data-testid="checkbox-header-delivery"
                        />
                        Unlimited
                      </span>
                    </TableCellHeader>
                  </TableRow>
                )}
              </TableHead>
              <TableBody>
                {(listMaterial && listMaterial.length) > 0 ? (
                  renderCollection(listMaterial, (line, index) => {
                    const isDisableCell =
                      isCancelItem(line) || isR5 || isCompleteDelivery(line);
                    return (
                      <TableRow key={line.itemNo}>
                        <TableCell
                          className={classNames(
                            classes.borderLeft,
                            classes.freezeCell
                          )}
                        >
                          <Checkbox
                            className={classes.checkBox}
                            size={"small"}
                            checked={isR5 ? false : isSelected(line.itemNo)}
                            onClick={() => toggle(line.itemNo)}
                            disabled={
                              isCancelItem(line) ||
                              disabled ||
                              isCompleteDelivery(line) ||
                              isR5
                            }
                            id={`checkbox-${line.id}`}
                            data-testid="checkbox-item"
                          />
                        </TableCell>
                        <TableCell className={classes.freezeCell1}>
                          <MyTypography
                            variant={"body3"}
                            className={classNames({
                              [classes.disabledItem]: isDisableCell
                            })}
                          >
                            {line.itemNo}
                          </MyTypography>
                        </TableCell>
                        <TableCell className={classes.freezeCell2}>
                          <MyTypography
                            variant={"body3"}
                            className={classNames({
                              [classes.disabledItem]: isDisableCell
                            })}
                          >
                            {line.material}
                          </MyTypography>
                        </TableCell>
                        <TableCell className={classes.freezeCell3}>
                          <MyTypography
                            variant={"body3"}
                            className={classNames({
                              [classes.disabledItem]: isDisableCell
                            })}
                          >
                            {line.materialDesc}
                          </MyTypography>
                          {isCancelItem(line) ? (
                            <MyTypography
                              variant={"caption"}
                              className={classes.boxCancel}
                            >
                              Cancel 93
                            </MyTypography>
                          ) : (
                            ""
                          )}
                        </TableCell>
                        <TableCell
                          className={classes.freezeCell4}
                          align={"center"}
                        >
                          {renderActionItem(line)}
                        </TableCell>
                        {tab === 0 ? (
                          <>
                            <TableCell
                              colSpan={2}
                              style={{ minWidth: "284px" }}
                              width={284}
                              data-testid="quantity-cell"
                            >
                              <div className={classes.boxQuantity}>
                                <MyTypography
                                  variant={"body3"}
                                  className={classNames({
                                    [classes.disabledItem]: isDisableCell
                                  })}
                                  style={{ minWidth: "112px" }}
                                >
                                  {isCancelItem(line) ? (
                                    <DecimalFormat
                                      value={+line.quantity}
                                      isGrayDecimal={false}
                                      countDecimal={0}
                                    />
                                  ) : (
                                    <NumberFormat
                                      inputDisabled={
                                        isOrderStatusPartialDelivery(line) ||
                                        isR5 ||
                                        isCompleteDelivery(line)
                                      }
                                      customClass={classes.numberInput}
                                      name={`quantity[${index}]`}
                                      id={`quantity-${line.id}`}
                                      testId="quantity-input"
                                      onChange={e =>
                                        handleChangeInput(
                                          e,
                                          line.itemNo,
                                          "quantity",
                                          null
                                        )
                                      }
                                      allowLeadingZeros
                                      decimalScale={0}
                                      placeholder={"ระบุจำนวน"}
                                      value={line.quantity}
                                      error={
                                        checkErrorByField("quantity", index) ||
                                        isErrorQuantity(line.itemNo)
                                      }
                                    />
                                  )}
                                </MyTypography>
                                <MyTypography
                                  variant={"body3"}
                                  className={classNames(classes.salesUnit, {
                                    [classes.disabledItem]: isDisableCell
                                  })}
                                >
                                  {isContainer(line) ? "EA" : "ROL"}
                                </MyTypography>
                              </div>
                              <span className={classes.txtError}>
                                {getErrorTextQuantity("quantity", index, line)}
                              </span>
                            </TableCell>
                            <TableCell align={"center"}>
                              <MyTypography
                                variant={"body3"}
                                className={classNames({
                                  [classes.disabledItem]: isDisableCell
                                })}
                              >
                                {isContainer(line) ? (
                                  "-"
                                ) : (
                                  <DecimalFormat
                                    value={Number(
                                      calculateTheWeight(
                                        line.weightUnit,
                                        Number(line.saleQtyFactor),
                                        Number(line.quantity)
                                      )?.toString()
                                    )}
                                    isGrayDecimal={false}
                                    countDecimal={3}
                                  />
                                )}
                              </MyTypography>
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {isContainer(line)
                                    ? ""
                                    : line.weightUnit ?? "TON"}
                                </MyTypography>
                              ) : (
                                <SingleSelectField
                                  InputProps={{
                                    classes: { input: classes.txtInputSelect },
                                    inputProps: {
                                      "data-testid": "weightUnit-input"
                                    }
                                  }}
                                  className={classes.selectField}
                                  choices={[
                                    {
                                      label: (
                                        <MyTypography variant={"subtitle3"}>
                                          TON
                                        </MyTypography>
                                      ),
                                      value: "TON"
                                    },
                                    {
                                      label: (
                                        <MyTypography variant={"subtitle3"}>
                                          Kg.
                                        </MyTypography>
                                      ),
                                      value: "Kg."
                                    }
                                  ]}
                                  onChange={e =>
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "weightUnit"
                                    )
                                  }
                                  placeholder={
                                    isContainer(line) ? "" : "Select"
                                  }
                                  value={
                                    isContainer(line)
                                      ? ""
                                      : line.weightUnit ?? "TON"
                                  }
                                  name={`weightUnit[${index}]`}
                                  id={`weightUnit-${line.id}`}
                                  error={checkErrorByField("weightUnit", index)}
                                  disabled={isDisableCell}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {isContainer(line)
                                    ? ""
                                    : line.itemCategory ?? "TON"}
                                </MyTypography>
                              ) : (
                                <SingleSelectField
                                  disabled={isR5 || isCompleteDelivery(line)}
                                  InputProps={{
                                    classes: { input: classes.txtInputSelect },
                                    inputProps: {
                                      "data-testid": "itemCategory-input"
                                    }
                                  }}
                                  className={classes.selectField}
                                  choices={
                                    isContainer(line)
                                      ? [
                                          {
                                            label: (
                                              <MyTypography
                                                variant={"subtitle3"}
                                              >
                                                ZKC0
                                              </MyTypography>
                                            ),
                                            value: "ZKC0"
                                          }
                                        ]
                                      : [
                                          {
                                            label: (
                                              <MyTypography
                                                variant={"subtitle3"}
                                              ></MyTypography>
                                            ),
                                            value: ""
                                          },
                                          {
                                            label: (
                                              <MyTypography
                                                variant={"subtitle3"}
                                              >
                                                ZTNN
                                              </MyTypography>
                                            ),
                                            value: "ZTNN"
                                          },
                                          {
                                            label: (
                                              <MyTypography
                                                variant={"subtitle3"}
                                              >
                                                ZTN1
                                              </MyTypography>
                                            ),
                                            value: "ZTN1"
                                          }
                                        ]
                                  }
                                  onChange={e =>
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "itemCategory"
                                    )
                                  }
                                  placeholder={"Select"}
                                  value={line.itemCategory}
                                  name={`itemCatEo[${index}]`}
                                  id={`itemCatEo-${line.id}`}
                                  error={checkErrorByField("itemCatEo", index)}
                                  allowBlank
                                />
                              )}
                            </TableCell>
                            <TableCell align={"right"}>
                              <MyTypography
                                variant={"body3"}
                                className={classNames({
                                  [classes.disabledItem]: isDisableCell
                                })}
                              >
                                {isContainer(line) ? (
                                  ""
                                ) : (
                                  <DecimalFormat
                                    value={Number(line?.conditionRate)}
                                    isGrayDecimal={false}
                                    countDecimal={2}
                                  />
                                )}
                              </MyTypography>
                            </TableCell>
                            <TableCell>
                              <MyTypography
                                variant={"body3"}
                                className={classNames({
                                  [classes.disabledItem]: isDisableCell
                                })}
                              >
                                {isContainer(line) ? "" : currency}
                              </MyTypography>
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {line.plant}
                                </MyTypography>
                              ) : (
                                <SingleTextField
                                  key={`plant[${index}${resetApplyPlant}]`}
                                  disabled={
                                    isOrderStatusPartialDelivery(line) ||
                                    isContainer(line) ||
                                    isDuringProduction(line) ||
                                    isAfterProduction(line) ||
                                    isItemProducing(line) ||
                                    isR5 ||
                                    isCompleteDelivery(line)
                                  }
                                  regex={REGEX_ONLY_NUMBER_CHARACTER}
                                  value={formik.values.plant[index]}
                                  name={`plant[${index}]`}
                                  id={`plant-${line.id}`}
                                  InputProps={{
                                    inputProps: { "data-testid": "plant-input" }
                                  }}
                                  className={classes.textFieldCustom}
                                  onChange={e =>
                                    handleChangeInput(e, line.itemNo, "plant")
                                  }
                                  maxLengthProps={4}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {line.refPiStock}
                                </MyTypography>
                              ) : (
                                <SingleTextField
                                  maxLengthProps={MAX_LENGTH_REF_PI}
                                  value={line.refPiStock}
                                  name={`refPiStock[${index}]`}
                                  id={`refPiStock-${line.id}`}
                                  InputProps={{
                                    inputProps: {
                                      "data-testid": "refPiStock-input"
                                    }
                                  }}
                                  className={classes.textFieldCustom}
                                  onChange={e =>
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "refPiStock"
                                    )
                                  }
                                  disabled={isDisableCell}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              <MyTypography
                                variant={"body3"}
                                className={classNames({
                                  [classes.disabledItem]: isDisableCell
                                })}
                              >
                                {line?.originalRequestDate
                                  ? line.originalRequestDate
                                  : "-"}
                              </MyTypography>
                            </TableCell>
                            <TableCell>
                              {isDisableCell ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {moment(line.requestDate).format(
                                    "DD/MM/YYYY"
                                  )}
                                </MyTypography>
                              ) : (
                                <DatePicker
                                  noBlock
                                  key={`requestDate[${index}${resetApplyDate}]`}
                                  disabled={
                                    isOrderStatusPartialDelivery(line) ||
                                    isCompleteDelivery(line)
                                  }
                                  value={line.requestDate}
                                  name={`requestDate[${index}]`}
                                  id={`requestDate-${line.id}`}
                                  data-testid="requestDate-input"
                                  onChange={e =>
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "requestDate"
                                    )
                                  }
                                  // error={
                                  //   !isOrderStatusPartialDelivery &&
                                  //   line.errorDate
                                  // }
                                  // helperText={
                                  //   !isOrderStatusPartialDelivery &&
                                  //   (line.errorDate
                                  //     ? line.dateBeforeConfirm
                                  //       ? textErrorDateConfirm
                                  //       : textErrorDate
                                  //     : "")
                                  // }
                                  error={line.errorDate}
                                  helperText={
                                    line.errorDate
                                      ? line.dateBeforeConfirm
                                        ? textErrorDateConfirm
                                        : textErrorDate
                                      : ""
                                  }
                                />
                              )}
                            </TableCell>
                            <TableCell align={"center"}>
                              <MyTypography
                                variant={"body3"}
                                className={classNames({
                                  [classes.disabledItem]: isDisableCell
                                })}
                              >
                                {line?.confirmDate
                                  ? moment(line.confirmDate).format(
                                      "DD/MM/YYYY"
                                    )
                                  : ""}
                              </MyTypography>
                            </TableCell>
                            <TableCell>
                              <MyTypography variant={"body3"}>
                                {getPlainTextFromEnum(line?.itemStatusEn)}
                              </MyTypography>
                            </TableCell>
                            <TableCell>
                              <MyTypography variant={"body3"}>
                                {line?.poSubcontract}
                              </MyTypography>
                            </TableCell>
                            <TableCell>
                              <MyTypography variant={"body3"}>
                                {line?.poStatus}
                              </MyTypography>
                            </TableCell>
                            <TableCell>
                              <Button
                                className={classes.button}
                                variant="contained"
                                onClick={() => {
                                  handleOpenModalInputParameter(line);
                                }}
                                color="secondary"
                                disabled={isDisableCell}
                                id={`input-parameter-button-${line.id}`}
                                data-testid="input-parameter-button"
                              >
                                <SVG src={externalLinkIcon} />
                              </Button>
                            </TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell>
                              {isDisableCell ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {formik.values.route[index]}
                                </MyTypography>
                              ) : (
                                <SearchRoute
                                  route={formik.values.route[index]}
                                  setRoute={handleChangeRoute}
                                  contractNo={data?.contractNo}
                                  itemId={line.itemNo}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {isDisableCell ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {formatConditionGroup(line)}
                                </MyTypography>
                              ) : (
                                <SingleSelectField
                                  menuListCustomStyle={{
                                    overflowY: "auto"
                                  }}
                                  InputProps={{
                                    classes: { input: classes.txtInputSelect },
                                    inputProps: {
                                      "data-testid": "conditionGroup1-input"
                                    }
                                  }}
                                  value={line?.conditionGroup1}
                                  onChange={e =>
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "conditionGroup1"
                                    )
                                  }
                                  name={`conditionGroup1[${index}]`}
                                  id={`conditionGroup1-${line.id}`}
                                  error={checkErrorByField(
                                    "conditionGroup1",
                                    index
                                  )}
                                  choices={conditionGroupOptions || []}
                                  className={classes.selectField}
                                  disabled={isCompleteDelivery(line)}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              <MyTypography
                                variant={"body3"}
                                className={classNames({
                                  [classes.disabledItem]: isDisableCell
                                })}
                              >
                                {line?.materialGroup1}
                              </MyTypography>
                            </TableCell>
                            <TableCell>
                              <MyTypography
                                variant={"body3"}
                                className={classNames({
                                  [classes.disabledItem]: isDisableCell
                                })}
                              >
                                {line?.commission}
                              </MyTypography>
                            </TableCell>
                            <TableCell>
                              <MyTypography
                                variant={"body3"}
                                className={classNames({
                                  [classes.disabledItem]: isDisableCell
                                })}
                              >
                                {line?.commissionAmount ? (
                                  <DecimalFormat
                                    value={Number(line?.commissionAmount)}
                                    isGrayDecimal={false}
                                    countDecimal={3}
                                  />
                                ) : (
                                  ""
                                )}
                              </MyTypography>
                            </TableCell>
                            <TableCell>
                              <MyTypography
                                variant={"body3"}
                                className={classNames({
                                  [classes.disabledItem]: isDisableCell
                                })}
                              >
                                {line?.commissionAmount
                                  ? line?.commissionUnit
                                  : ""}
                              </MyTypography>
                            </TableCell>
                            <TableCell className={classes.noBorderRight}>
                              {isDisableCell ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {line.deliveryTolUnlimited
                                    ? "0"
                                    : formik.values.deliveryTolUnder[index]}
                                </MyTypography>
                              ) : (
                                <MyTypography variant={"body3"}>
                                  <SingleTextFieldNoBlock
                                    name={`deliveryTolUnder[${index}]`}
                                    id={`deliveryTolUnder-${line.id}`}
                                    InputProps={{
                                      inputProps: {
                                        "data-testid": "deliveryTolUnder-input"
                                      }
                                    }}
                                    value={
                                      line.deliveryTolUnlimited
                                        ? "0"
                                        : formik.values.deliveryTolUnder[index]
                                    }
                                    error={checkErrorByField(
                                      "deliveryTolUnder",
                                      index
                                    )}
                                    onChange={e => {
                                      if (!line.deliveryTolUnlimited) {
                                        handleChangeInput(
                                          e,
                                          line.itemNo,
                                          "deliveryTolUnder"
                                        );
                                      }
                                    }}
                                    disabled={isSelectedDelivery(line.itemNo)}
                                    className={classNames(
                                      classes.textFieldCustom,
                                      {
                                        [classes.disabled]: isSelectedDelivery(
                                          line.itemNo
                                        )
                                      }
                                    )}
                                    regex={REGEX_ONLY_NUMBER}
                                    numberLimit={100}
                                  />
                                </MyTypography>
                              )}
                            </TableCell>
                            <TableCell className={classes.noBorderRight}>
                              {isDisableCell ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {line.deliveryTolUnlimited
                                    ? "0"
                                    : formik.values.deliveryTolOver[index]}
                                </MyTypography>
                              ) : (
                                <MyTypography variant={"body3"}>
                                  <SingleTextFieldNoBlock
                                    name={`deliveryTolOver[${index}]`}
                                    id={`deliveryTolOver-${line.id}`}
                                    InputProps={{
                                      inputProps: {
                                        "data-testid": "deliveryTolOver-input"
                                      }
                                    }}
                                    value={
                                      line.deliveryTolUnlimited
                                        ? "0"
                                        : formik.values.deliveryTolOver[index]
                                    }
                                    error={checkErrorByField(
                                      "deliveryTolOver",
                                      index
                                    )}
                                    onChange={e => {
                                      if (!line.deliveryTolUnlimited) {
                                        handleChangeInput(
                                          e,
                                          line.itemNo,
                                          "deliveryTolOver"
                                        );
                                      }
                                    }}
                                    disabled={isSelectedDelivery(line.itemNo)}
                                    className={classNames(
                                      classes.textFieldCustom,
                                      {
                                        [classes.disabled]: isSelectedDelivery(
                                          line.itemNo
                                        )
                                      }
                                    )}
                                    regex={REGEX_ONLY_NUMBER}
                                    numberLimit={100}
                                  />
                                </MyTypography>
                              )}
                            </TableCell>
                            <TableCell className={classes.unlimited}>
                              <span className={classes.delivery}>
                                <Checkbox
                                  size={"small"}
                                  name={`deliveryTolUnlimited`}
                                  id={`deliveryTolUnlimited-${line.id}`}
                                  data-testid="deliveryTolUnlimited-checkbox"
                                  checked={isSelectedDelivery(line.itemNo)}
                                  onClick={e =>
                                    handleClickCheckBox(e, line.itemNo)
                                  }
                                  disabled={isDisableCell || disabled}
                                />
                                Unlimited
                              </span>
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {isK01K09(line) ||
                                  isContainer(line) ||
                                  isSpecialPlant(line)
                                    ? ""
                                    : formik.values.rollDiameter[index]}
                                </MyTypography>
                              ) : (
                                <SingleTextField
                                  name={`rollDiameter[${index}]`}
                                  id={`rollDiameter-${line.id}`}
                                  InputProps={{
                                    inputProps: {
                                      "data-testid": "rollDiameter-input"
                                    }
                                  }}
                                  value={
                                    isK01K09(line) || isContainer(line)
                                      ? ""
                                      : formik.values.rollDiameter[index]
                                  }
                                  disabled={
                                    isK01K09(line) ||
                                    isContainer(line) ||
                                    isR5 ||
                                    isSpecialPlant(line) ||
                                    isCompleteDelivery(line)
                                  }
                                  className={classes.textFieldCustom}
                                  onChange={e =>
                                    !(isK01K09(line) || isContainer(line)) &&
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "rollDiameter"
                                    )
                                  }
                                  error={
                                    isK01K09(line) || isContainer(line)
                                      ? false
                                      : checkErrorByField("rollDiameter", index)
                                  }
                                  maxLengthProps={10}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {isK01K09(line) ||
                                  isContainer(line) ||
                                  isSpecialPlant(line)
                                    ? ""
                                    : formik.values.rollCoreDiameter[index]}
                                </MyTypography>
                              ) : (
                                <SingleTextField
                                  name={`rollCoreDiameter[${index}]`}
                                  id={`rollCoreDiameter-${line.id}`}
                                  InputProps={{
                                    inputProps: {
                                      "data-testid": "rollCoreDiameter-input"
                                    }
                                  }}
                                  value={
                                    isK01K09(line) || isContainer(line)
                                      ? ""
                                      : formik.values.rollCoreDiameter[index]
                                  }
                                  disabled={
                                    isK01K09(line) ||
                                    isContainer(line) ||
                                    isR5 ||
                                    isSpecialPlant(line)
                                  }
                                  className={classes.textFieldCustom}
                                  onChange={e =>
                                    !(isK01K09(line) || isContainer(line)) &&
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "rollCoreDiameter"
                                    )
                                  }
                                  error={
                                    isK01K09(line) || isContainer(line)
                                      ? false
                                      : checkErrorByField(
                                          "rollCoreDiameter",
                                          index
                                        )
                                  }
                                  maxLengthProps={10}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {isK01K09(line) || isContainer(line)
                                    ? ""
                                    : formik.values.rollQuantity[index]}
                                </MyTypography>
                              ) : (
                                <SingleTextField
                                  name={`rollQuantity[${index}]`}
                                  id={`rollQuantity-${line.id}`}
                                  InputProps={{
                                    inputProps: {
                                      "data-testid": "rollQuantity-input"
                                    }
                                  }}
                                  value={
                                    isK01K09(line) || isContainer(line)
                                      ? ""
                                      : formik.values.rollQuantity[index]
                                  }
                                  disabled={
                                    isK01K09(line) || isContainer(line) || isR5
                                  }
                                  className={classes.textFieldCustom}
                                  onChange={e =>
                                    !(isK01K09(line) || isContainer(line)) &&
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "rollQuantity"
                                    )
                                  }
                                  error={
                                    isK01K09(line) || isContainer(line)
                                      ? false
                                      : checkErrorByField("rollQuantity", index)
                                  }
                                  maxLengthProps={10}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {isK01K09(line) ||
                                  isContainer(line) ||
                                  isSpecialPlant(line)
                                    ? ""
                                    : line?.reamRollPerPallet}
                                </MyTypography>
                              ) : (
                                <SingleTextField
                                  name={`rollPerPallet[${index}]`}
                                  id={`rollPerPallet-${line.id}`}
                                  InputProps={{
                                    inputProps: {
                                      "data-testid": "rollPerPallet-input"
                                    }
                                  }}
                                  value={
                                    isK01K09(line) || isContainer(line)
                                      ? ""
                                      : line?.reamRollPerPallet
                                  }
                                  disabled={
                                    isK01K09(line) ||
                                    isContainer(line) ||
                                    isR5 ||
                                    isSpecialPlant(line)
                                  }
                                  className={classes.textFieldCustom}
                                  onChange={e =>
                                    !(isK01K09(line) || isContainer(line)) &&
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "rollPerPallet"
                                    )
                                  }
                                  regex={REGEX_ONLY_NUMBER}
                                  error={
                                    isK01K09(line) || isContainer(line)
                                      ? false
                                      : checkErrorByField(
                                          "rollPerPallet",
                                          index
                                        )
                                  }
                                  maxLengthProps={10}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {isK01K09(line) ||
                                  isContainer(line) ||
                                  isSpecialPlant(line)
                                    ? ""
                                    : formik.values.palletSize[index]}
                                </MyTypography>
                              ) : (
                                <SingleTextField
                                  name={`palletSize[${index}]`}
                                  id={`palletSize-${line.id}`}
                                  InputProps={{
                                    inputProps: {
                                      "data-testid": "palletSize-input"
                                    }
                                  }}
                                  value={
                                    isK01K09(line) || isContainer(line)
                                      ? ""
                                      : formik.values.palletSize[index]
                                  }
                                  disabled={
                                    isK01K09(line) ||
                                    isContainer(line) ||
                                    isR5 ||
                                    isSpecialPlant(line)
                                  }
                                  className={classes.textFieldCustom}
                                  onChange={e =>
                                    !(isK01K09(line) || isContainer(line)) &&
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "palletSize"
                                    )
                                  }
                                  error={
                                    isK01K09(line) || isContainer(line)
                                      ? false
                                      : checkErrorByField("palletSize", index)
                                  }
                                  maxLengthProps={10}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {isK01K09(line) || isContainer(line)
                                    ? ""
                                    : line.palletNo}
                                </MyTypography>
                              ) : (
                                <SingleTextField
                                  name={`palletNo[${index}]`}
                                  id={`palletNo-${line.id}`}
                                  InputProps={{
                                    inputProps: {
                                      "data-testid": "palletNo-input"
                                    }
                                  }}
                                  value={
                                    isK01K09(line) || isContainer(line)
                                      ? ""
                                      : line.palletNo
                                  }
                                  disabled={
                                    isK01K09(line) ||
                                    isContainer(line) ||
                                    isR5 ||
                                    isSpecialPlant(line)
                                  }
                                  className={classes.textFieldCustom}
                                  onChange={e =>
                                    !(isK01K09(line) || isContainer(line)) &&
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "palletNo"
                                    )
                                  }
                                  error={
                                    isK01K09(line) || isContainer(line)
                                      ? false
                                      : checkErrorByField("palletNo", index)
                                  }
                                  maxLengthProps={10}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {isK01K09(line) || isContainer(line)
                                    ? ""
                                    : line?.noOfPackage}
                                </MyTypography>
                              ) : (
                                <SingleTextField
                                  name={`packageQuantity[${index}]`}
                                  id={`packageQuantity-${line.id}`}
                                  InputProps={{
                                    inputProps: {
                                      "data-testid": "packageQuantity-input"
                                    }
                                  }}
                                  value={
                                    isK01K09(line) || isContainer(line)
                                      ? ""
                                      : line?.noOfPackage
                                  }
                                  disabled={
                                    isK01K09(line) ||
                                    isContainer(line) ||
                                    isR5 ||
                                    isSpecialPlant(line)
                                  }
                                  className={classes.textFieldCustom}
                                  onChange={e =>
                                    !(isK01K09(line) || isContainer(line)) &&
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "packageQuantity"
                                    )
                                  }
                                  regex={REGEX_ONLY_NUMBER}
                                  error={
                                    isK01K09(line) || isContainer(line)
                                      ? false
                                      : checkErrorByField(
                                          "packageQuantity",
                                          index
                                        )
                                  }
                                  maxLengthProps={10}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {isK01K09(line) ||
                                  isContainer(line) ||
                                  isSpecialPlant(line)
                                    ? ""
                                    : line.packingList}
                                </MyTypography>
                              ) : (
                                <SingleTextField
                                  name={`packingList[${index}]`}
                                  id={`packingList-${line.id}`}
                                  InputProps={{
                                    inputProps: {
                                      "data-testid": "packingList-input"
                                    }
                                  }}
                                  value={
                                    isK01K09(line) || isContainer(line)
                                      ? ""
                                      : line.packingList
                                  }
                                  disabled={
                                    isK01K09(line) ||
                                    isContainer(line) ||
                                    isR5 ||
                                    isSpecialPlant(line)
                                  }
                                  className={classes.textFieldCustom}
                                  onChange={e =>
                                    !(isK01K09(line) || isContainer(line)) &&
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "packingList"
                                    )
                                  }
                                  maxLengthProps={132}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classes.disabledItem}
                                >
                                  {isK01K09(line) || isContainer(line)
                                    ? ""
                                    : formik.values.shippingPoint[index]}
                                </MyTypography>
                              ) : (
                                <SingleTextField
                                  name={`shippingPoint[${index}]`}
                                  id={`shippingPoint-${line.id}`}
                                  InputProps={{
                                    inputProps: {
                                      "data-testid": "shippingPoint-input"
                                    }
                                  }}
                                  value={formik.values.shippingPoint[index]}
                                  className={classes.textFieldCustom}
                                  onChange={e =>
                                    handleChangeInput(
                                      e,
                                      line.itemNo,
                                      "shippingPoint"
                                    )
                                  }
                                  error={checkErrorByField(
                                    "shippingPoint",
                                    index
                                  )}
                                  regex={REGEX_ONLY_NUMBER}
                                  disabled={isR5 || isCompleteDelivery(line)}
                                  maxLengthProps={4}
                                />
                              )}
                            </TableCell>
                            <TableCell>
                              {isCancelItem(line) ? (
                                <MyTypography
                                  variant={"body3"}
                                  className={classNames(
                                    classes.disabledItem,
                                    classes.pre
                                  )}
                                >
                                  {isK01K09(line) || isContainer(line)
                                    ? ""
                                    : line?.remark}
                                </MyTypography>
                              ) : (
                                <TextAreaField
                                  value={line?.remark}
                                  name={`remark[${index}]`}
                                  id={`remark-${line.id}`}
                                  data-testid="remark-input"
                                  className={classes.textFieldCustom}
                                  onChange={e =>
                                    handleChangeInput(e, line.itemNo, "remark")
                                  }
                                  verticalResizingOnly
                                  rowsMin={1}
                                  maxLength={1320}
                                  lineLimit={132}
                                  rowsMax={10}
                                  disabled={isR5 || isCompleteDelivery(line)}
                                />
                              )}
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={totalCols}>
                      <Skeleton />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            {listMaterial && listMaterial.length ? (
              <StickyHorizontalScrollBar
                container={containerRef}
                reRender={reRender}
                bottom={fullScreen ? 0 : 165}
              />
            ) : null}
          </div>
          <TablePaginationCustom
            hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
            hasPreviousPage={
              pageInfo && !disabled ? pageInfo.hasPreviousPage : false
            }
            onNextPage={onNextPage}
            onPreviousPage={onPreviousPage}
            totalCount={totalCount}
            selectColor="#007E92"
            settings={settings}
            onUpdateListSettings={onUpdateListSettings}
            isBackFistPage
            isNextLastPage
            latestPageItemNumber={latestPageItemNumber}
            onNextLastPage={onNextLastPage}
            onPreviousFirstPage={onPreviousFirstPage}
            disabled={disabled}
          />
        </>
      ) : null}
      {!listMaterial?.length ? <EmptyProduct hideTotal /> : null}

      <ModalInputParameter
        key={keyComponent}
        open={isOpenModalInputParameter}
        initialValue={orderLine?.inquiryMethod}
        allowChangeInquiryMethod={orderLine?.allowChangeInquiryMethod}
        onClose={handleCloseModalInputParameter}
        onSave={handleSaveInputParameter}
        isOrderStatusPartialDelivery={isPartialDelivery}
      />
    </>
  );
};

export default MaterialItemTabEdit;
